module.exports = __webpack_public_path__ + "static/media/m-kids.bfe0f289.svg";


//////////////////
// WEBPACK FOOTER
// ./src/atoms/Nav/m-kids.svg
// module id = 583
// module chunks = 0